import React, { useState,useRef } from 'react';
import { Calendar, Views,momentLocalizer } from 'react-big-calendar'
import events from './events';
import moment from 'moment'
import  'react-big-calendar/lib/css/react-big-calendar.css';
import Schedule from './Schedule';
import { Link,useNavigate } from 'react-router-dom';




const localizer = momentLocalizer(moment)

// const localizer = momentLocalizer(moment)


function ConsultancyItem(props) {
  const {details} =props
  const {name,teacher_type,speaks,trial_rate,hourly_rate,teacher_from,category}=details
  const navigate = useNavigate();
  const [faculty, setFaculty] = useState(true);
  const [video, setVideo] = useState(true);
  const ref = useRef()
  
  let handleClick=(event)=>{
    event.stopPropagation()
    navigate("/globalConsultancy/teacher")
  }
  return (
    <>
{/* <Link ref={ref} to="/globalConsultancy/teacher"></Link> */}
    <div className="p-3 my-5 mdb-color darken-3    rounded    " onClick={handleClick} >
      <div className="row justify-content-center " >
        <div className="col-md-2 d-flex flex-column align-items-center justify-content-center" >
          <img src={require(`../../resource/testimonial-1.jpg`)} style={{ width: '100px', height: '100px', boxShadow: '0 0 0  5px purple' }} className="rounded-circle" alt="" />
          <div className="white-3 mt-1 h6">{teacher_type}</div>
          <div className="white-3 h6">From <span className="white-2 letter-dis-1" style={{ borderBottom: "3px dashed #800080"}} >{teacher_from.toUpperCase()}</span> 
          </div>
          <div className="review mt-3 white-3 ">
            <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
            <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
            <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
            <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
            <ion-icon name="star-half-outline" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
            &#160;4.5
          </div>
          <p className="white-2">17 Lessons</p>
          <a href="" className="btn white-text deep-orange btn-">Book now</a>
        </div>
        <div className="col-md-9"  >
          <div className="d-flex justify-content-center" onClick={(event) =>event.stopPropagation()}>
            <div className="btn-group ">
              <a onClick={() => setFaculty(true)} className={`btn-lg ${faculty ? "purple darken-2 " : "purple darken-4 "} rounded text-white mr-2`}>Faculty details</a>
              <a onClick={() => setFaculty(false)} className={`btn-lg ${!faculty ? "purple darken-2" : "purple darken-4 "} rounded text-white`}>Available schedules</a>
            </div>
          </div>

          <div className={`row p-2 justify-content-evenly ${!faculty && "d-none"} animated fadeIn `}>
            <div className="col-md-5 d-flex flex-column justify-content-evenly align-items-start" >
              <h4 className="white-1">{name}</h4>
              <span className="white-2 mt-1 h5" style={{ borderBottom: "4px dashed #800080" }}>{category}</span>
              <div className="my-2">
                <h5 className="white-3">Speaks</h5>
                <div className="d-flex">
                  <h4 className="mr-5 white-2">{speaks[0]}</h4>
                  <h4 className="white-2">{speaks[1]}</h4>
                </div>
              </div>
              <div className="d-flex ">
                <div className="mr-5">
                  <h5 className="white-4">30 min trial</h5>
                  <h4 className="white-2">INR {trial_rate}</h4>
                </div>
                <div>
                  <h5 className="white-4">Hourly rate from</h5>
                  <h4 className="white-2">INR {hourly_rate}</h4>
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex flex-column align-items-center justify-content-between" >
              <div className="d-flex justify-content-center" onClick={(event) =>event.stopPropagation()} >
                <div className="btn-group " >
                  <a onClick={() => setVideo(true)} className={` ${video ? "text-white " : "grey-text "}  h6 letter-dis-2 mr-3`}>Video</a>
                  <a onClick={() => setVideo(false)} className={` ${!video ? "text-white " : "grey-text "} h6 letter-dis-2 `}>Intro</a>
                </div>
              </div>
              <div class={`embed-responsive embed-responsive-16by9  hoverable ${!video && "d-none"} animated fadeIn`} style={{ width: "86%", height: "85%" }} >
                <iframe class="embed-responsive-item" width="560" height="315" style={{ height: "101%" }} src="https://www.youtube.com/embed/chRx0xsLGAk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                
              </div>
            <div className={`white-3 d-flex  px-3 ${video && "d-none"}  animated fadeIn `}>
            <span className="text-terminate text-terminate-9" >

            Lorem ipsum dolorjkdkljfkdljfdsk dfjsldkjfsd fk sdkfjdsljflksdjf sdjf sdfkjlsdkjflksdjf sit amet lorem orem ipsum dolor sit amet lorem consectetur adipisicing elit. Rerum dicta fugit voluptatem recusandae quis quos consequatur laudantium nulla laborum explicabo quidem impedit corporis quas perferendis blanditiis, cupiditate sint voluptate quaerat excepturi in, ratione maiores ab. Nesciunt, nobis, praesentium possimus non illum consectetur magni fuga facere, perspiciatis incidunt quibusdam maiores accusamus?
            </span>
            <a href="" className="align-self-end purple-text letter-dis-1" >More</a>
            </div>
            </div>
          </div>

          <div className={`p-2  ${faculty && "d-none"} white-2 animated fadeIn hideScrollbar`} onClick={(event) =>event.stopPropagation()} >
          <Schedule/>
          {/* <Calendar
    events={events}
    // defaultView={Views.WEEK}
    selectable
          localizer={localizer}
          defaultView={Views.WEEK}
          scrollToTime={new Date(1970, 1, 1, 6)}
          defaultDate={new Date(2015, 3, 12)}
          onSelectEvent={event => alert(event.title)}
          onSelectSlot={handleSelect}  
  /> */}
          </div>

        </div>
      </div>
    </div>
    </>
  )
}

export default ConsultancyItem;
